import styled, { css } from "styled-components";

import { fontStyle } from "@pages/casino/assets/styles/mixins";

export const SearchWrapper = styled.div`
	.modal-item {
		max-height: 100vh;
	}

	${({ hasLessBorderRadius }) =>
		hasLessBorderRadius &&
		css`
			${SearchIconContainer} {
				border-radius: 10px;
				border: 1px solid var(--search-button-border);
				background: var(--search-button-gradient);
			}
		`}
`;

export const SearchIcon = styled.svg`
	width: 18px;
	height: 17px;
	color: var(--main-text-color);
	fill: var(--main-text-color);
`;

export const SearchIconContainer = styled.button`
	display: flex;
	height: 30px;
	width: 30px;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	outline: none;
	border: none;
	background: var(--main-gradient);
	cursor: pointer;

	@media (min-width: 1600px) {
		height: 40px;
		width: 40px;
	}

	:hover {
		opacity: 0.7;
	}
	svg {
		width: 25px;
		height: 25px;
		padding-bottom: 2px;

		@media (min-width: 1600px) {
			width: 30px;
			height: 100%;
		}
	}

	${({ isDesktop }) =>
		isDesktop &&
		css`
			width: 163px;
			height: ${({ isSmaller }) => (isSmaller ? "30px" : "40px")};
			border-radius: 20px;
			gap: 5px;
			border-radius: 20px;

			svg {
				width: 24px;
				height: 24px;
				path {
					fill: var(--button-color);
				}
			}

			span {
				color: var(--button-color);
				text-align: center;
				font-size: ${({ isSmaller }) => (isSmaller ? "12px" : "14px")};
				font-weight: 600;
				line-height: 20px;
				letter-spacing: 0.75px;
			}

			@media (min-width: 1600px) {
				width: 163px;
				height: 40px;
				span {
					font-size: ${({ isSmaller }) => isSmaller && "14px"};
				}
			}
		`}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	margin-top: 80px;
	min-height: 70vh;
	position: relative;

	@media (min-width: 768px) {
		margin-top: 100px;
	}

	.modal-close-icon {
		bottom: 90px;
		cursor: pointer;
		border-radius: 25px;
		border: 1px solid var(--border-bg-color);
		background: var(--modal-bg);
		width: 50px;
		height: 50px;
		transform: rotate(90deg);
		justify-content: center;
		padding: 10px;
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
		position: fixed;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;

		@media (min-width: 1024px) {
			bottom: 60px;
		}
	}

	.game-image-wrapper {
		width: max-content;
	}

	.img-container {
		width: max-content;
	}

	.search-game-container {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		gap: 10px;
		overflow-y: auto;
		height: unset;
		padding: 0 0 150px 0;

		@media (min-width: 375px) {
			max-width: 375px;
			width: 375px;
		}

		@media (min-width: 425px) {
			max-width: 400px;
			width: 400px;
		}

		@media (min-width: 768px) {
			max-width: 428px;
			width: 428px;
		}

		@media (min-width: 1024px) {
			max-width: 574px;
			width: 574px;
		}

		@media (min-width: 1600px) {
			max-width: 780px;
			width: 780px;
		}

		&::-webkit-scrollbar {
			display: none;
		}
	}
`;

export const CloseIconOverlay = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 214px;
	background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0) 100%);
	z-index: 9;
	pointer-events: none;
`;

export const SearchContainer = styled.div`
	display: flex;
	width: 300px;
	height: 40px;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	padding: 10px 20px;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	margin: 0 auto;

	${(props) =>
		!props.isBottomRadius &&
		"border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;"}
	background-color: var(--dark);
	${({ noValue, hasItem }) =>
		!noValue
			? hasItem
				? css`
						border-top: 1px solid var(--Green-dark, #067306);
						border-bottom: 1px solid var(--Green-dark, #067306);
					`
				: css`
						border-top: 1px solid var(--Red-dark, #940136);
						border-bottom: 1px solid var(--Red-dark, #940136);
					`
			: css`
					border-top: 1px solid var(--main-color-dark);
					border-bottom: 1px solid var(--main-color-dark);
				`};

	@media (min-width: 425px) {
		width: 350px;
	}

	@media (min-width: 768px) {
		width: 438px;
	}

	@media (min-width: 1024px) {
		width: 584px;
	}

	@media (min-width: 1440px) {
		height: 50px;
		border-top-left-radius: 30px;
		border-top-right-radius: 30px;
		${(props) =>
			!props.isBottomRadius &&
			"border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;"}
	}

	@media (min-width: 1600px) {
		width: 720px;
	}

	.search-input-trash-icon {
		cursor: pointer;
	}

	input {
		padding: 0 10px;
		width: 100%;
		height: 40px;
		border: none;
		border: none;
		outline: none;
		color: var(--main-text-color);
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		background-color: transparent;
		&::placeholder {
			color: var(--main-text-color);
			opacity: 1; /* Firefox */
		}

		&::-ms-input-placeholder {
			/* Edge 12 -18 */
			color: var(--main-text-color);
		}
		@media (min-width: 1440px) {
			height: 50px;
			font-size: 15px;
			font-style: normal;
			font-weight: 600;
			line-height: 24.938px; /* 166.251% */
			letter-spacing: 0.374px;
		}
	}

	svg {
		@media (min-width: 1440px) {
			width: 32px;
			height: 32px;
		}
	}
`;

export const Heading = styled.h1`
	text-align: center;
	color: var(--main-explosive);
	font-size: 16px;
	font-weight: 400;
	line-height: 32px;
	letter-spacing: 0.75px;
	text-transform: capitalize;
	margin-bottom: 10px;
`;

export const InfoText = styled.p`
	font-size: 10px;
	font-style: normal;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.25px;
	padding: 10px 0;
	color: var(--main-text-color);
	margin: 0 auto;

	@media (min-width: 1440px) {
		line-height: 14.963px;
		letter-spacing: 0.312px;
		font-size: 14px;
	}
`;

export const MatchList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
`;

export const MatchItem = styled.li`
	padding: 10px;
	border-radius: 4px;
	border: 1px solid #ccc;
	margin-bottom: 10px;
`;

export const SearchFilterWrapper = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	gap: 5px;
	margin-bottom: 10px;

	@media (min-width: 768px) {
		gap: 0;
	}

	@media (min-width: 1600px) {
		gap: 30px;
	}
`;

export const SearchFilter = styled.div`
	display: flex;
	cursor: pointer;
	min-width: 90px;
	height: 20px;
	color: var(--secondary-text-color);
	${fontStyle}
	align-items: center;
	justify-content: center;

	img {
		width: 18px;
		margin-right: 5px;
	}

	svg {
		margin-right: 5px;
		width: 18px;

		stop {
			stop-color: var(--secondary-text-color);
		}
	}

	@media (min-width: 768px) {
		min-width: 140px;
	}

	@media (min-width: 1024px) {
		min-width: 160px;
	}

	${({ isActive }) =>
		isActive &&
		css`
			color: var(--main-color);

			svg {
				path {
					fill: var(--main-color);
				}
			}
		`}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			${({ isActive }) =>
				isActive &&
				css`
					color: var(--main-explosive);

					svg {
						path {
							fill: var(--main-explosive);
						}
					}
				`}
		`}
`;

export const SearchNoContentWrapper = styled.div`
	display: flex;
	width: 300px;

	@media (min-width: 425px) {
		width: 350px;
	}

	@media (min-width: 768px) {
		width: 438px;
	}

	@media (min-width: 1024px) {
		width: 584px;
	}

	@media (min-width: 1600px) {
		width: 720px;
	}
`;

export const GameContainer = styled.div`
	width: 325px;
	padding: 0px 20px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	gap: 10px;
	@media (min-width: 425px) {
		width: 390px;
	}
	@media (min-width: 570px) {
		width: 100%;
	}

	@media (min-width: 744px) {
		padding: 0 16px;
	}

	@media (min-width: 1024px) {
		width: 890px;
		padding: 0;
		justify-content: flex-start;
	}
	@media (min-width: 1280px) {
		width: 1250px;
	}

	@media (min-width: 1600px) {
		width: 1434px;
	}

	@media (min-width: 1024px) {
		#game-image-wrapper {
			.img-container {
				&::after {
					${() =>
						window.HOMEPAGE_AND_CASINO_PAGES_GAME_CARD_HAS_NO_SHADOW &&
						css`
							box-shadow: inset 0 0 7px 3px #1d0637d4;
							filter: drop-shadow(10px 10px 10px rgba(29, 10, 55, 1));
						`}
				}
			}
		}
	}
`;
